import { EventType } from "./constants/event-type-constants";
import { MarketingClientConstants } from "./constants/marketing-client-constants";
import { RwSelector } from "./constants/rw-object.constants";
import { DOMHelper } from "./helpers/dom-helper";
import { httpInstance } from "./http/http";
import { Capping } from "./marketing-client-capping";
import { MarketingClientRWBase } from "./marketing-client-rw-base";
import { Utilization } from "./marketing-client-utilization";
import { Checkbox } from "./utils/checkbox";
import { Spinner } from "./utils/spinner";
import { BigDataClickID } from "./constants/big-data-constants";
import { CtaObject, Utils } from "./utils/utils";
import { LiveSession } from "./utils/livesession";

export class MarketingClientRWSecondPromotion extends MarketingClientRWBase {
    subscribeNewsletterButton: HTMLElement | null;
    subscribeNewsletterError: HTMLElement | null;
    checkbox: Checkbox;
    spinner: Spinner;
    ctaObject: CtaObject;

    idPrefixSelector = "rwSecondPromotion-";
    idSuffixCheckboxA = "form-checkbox-A";
    classSuffix = {
        subscribeNewsletterButton: "_form-button",
        subscribeNewsletterError: "_form-subscribe-newsletter-error",
        subscribeNewsletterAccount: "_form-spinner",
    };

    constructor(
        public capping: Capping,
        public utilizationObject: Utilization,
        public classSection: string = RwSelector.rwSecondPromotionSelector
    ) {
        super(capping, utilizationObject, classSection);
    }

    init(): void {
        this.initialize();
        this.initializeForm();

        if (!this.section || !this.subscribeNewsletterButton) {
            return;
        }

        this.initializeCheckbox();
        this.initializeSpinner();
        this.initializeLiveSession();
        this.bindEvents();
        this.showSection();
        this.showDdbox();
        if (!this.ddbox) this.showSwimmer();
    }

    initializeForm(): void {
        if (this.section) {
            this.subscribeNewsletterButton = DOMHelper.querySelector(`${this.classSection}${this.classSuffix.subscribeNewsletterButton}`, this.section) as HTMLElement;
            this.subscribeNewsletterError = DOMHelper.querySelector(`${this.classSection}${this.classSuffix.subscribeNewsletterError}`, this.section) as HTMLElement;
        }
    }

    initializeSpinner(): void {
        this.spinner = new Spinner(`${this.classSection}${this.classSuffix.subscribeNewsletterAccount}`);
    }

    initializeCheckbox(): void {
        this.checkbox = new Checkbox(`${this.idPrefixSelector}${this.idSuffixCheckboxA}`);
    }

    initializeLiveSession() {
        if (!this.section) return;
        new LiveSession(this.section).init();
    }

    bindEvents(): void {
        this.bindEventsToSubscribeNewsletter();
        this.bindSwimmerEvents();
    }

    bindEventsToSubscribeNewsletter(): void {
        if (this.subscribeNewsletterButton) {
            this.subscribeNewsletterButton.addEventListener(EventType.CLICK, (event) => {
                event.preventDefault();

                this.validateBeforeSubscribing();
            });
        }
    }

    validateBeforeSubscribing(): void {
        if (this.checkbox.isValidate()) {
            this.checkbox.hideError();
            this.hideError();
            this.spinner.show();
            this.utilize(BigDataClickID.signupAndContinue);
            this.subscribeNewsletter();
        } else {
            this.checkbox.showError();
        }
    }

    subscribeNewsletter(): Promise<any> {
        return httpInstance
            .post({
                url: `${this.squidHomeUrl}squid-home/restricted/newsletters`,
                withCredentials: true
            })
            .then(this.goToMK.bind(this), this.showError.bind(this))
            .then(() => {
                this.spinner.hide();
            });
    }

    goToMK(): void {
        const location = window.location.href,
            locationWithoutHash = location.toString().replace(/#.*/g, "");

        if (this.section) {
          this.ctaObject = Utils.prepareCtaObject(this.section);
        }

        window.location.href = `https://mojekonto.wyborcza.pl/account/subscriptions?articleLink="${locationWithoutHash}"&registrationWall=true&cta=${this.ctaObject.cta}#settings`;
    }

    showError(): void {
        this.subscribeNewsletterError?.classList.remove(MarketingClientConstants.hiddenClassName);
    }

    hideError(): void {
        this.subscribeNewsletterError?.classList.add(MarketingClientConstants.hiddenClassName);
    }
}
